/**
 * Converts flat query keys used in the URL (e.g. status[eq], createdAt[gte])
 * into the nested JSON shape expected by POST /v2/merchants/orders.
 *
 * @param {Record<string, unknown>} flat
 * @returns {Record<string, unknown>}
 */
function normalizeBracketFilterToNested(flat) {
  if (!flat || typeof flat !== 'object') {
    return flat
  }

  const nested = {}
  const bracketKeyRe = /^([a-zA-Z][a-zA-Z0-9_]*)\[(in|eq|gte|lte|like)\]$/

  for (const [fullKey, rawValue] of Object.entries(flat)) {
    if (rawValue === undefined || rawValue === null) {
      continue
    }

    if (fullKey === 'merchantIds' || fullKey === 'merchantIds[]') {
      nested.merchantIds = Array.isArray(rawValue) ? rawValue : [rawValue]
      continue
    }

    const match = fullKey.match(bracketKeyRe)
    if (!match) {
      nested[fullKey] = rawValue
      continue
    }

    const [, field, op] = match
    if (!nested[field]) {
      nested[field] = {}
    }
    nested[field][op] = rawValue
  }

  return nested
}

export { normalizeBracketFilterToNested }
